import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { UserService } from 'src/app/services/user/user.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Injectable({
    providedIn: 'root'
})
export class HeaderUtilsService {

    constructor(
        private router: Router,
        private userService: UserService,
        private utilsService:UtilsService,
        private authService:AuthService
    ) { }

    openSearchPage() {
        this.router.navigate(['search-items']);
    }

     getLoginStatus() {
        let loginStatus:boolean;
        let userId = this.userService.getUserId();
        if (userId === '') {
            loginStatus = false;
        } else {
            loginStatus = true;
        }
        return loginStatus;
    }

    async openLoginModal() {
      this.utilsService.openLoginModal();
  }

  
  logout(){
    this.authService.logout();
}
}
